import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../../auth/guard.ts'
import { NAV_PATHS } from '../../navigation/paths.ts'
import { rootRoute } from '../root.tsx'

// The campi the club plays on, whether each has its camera, and what the box runs.
export const officialPitchesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: NAV_PATHS.officialPitches,
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['club'],
      currentPath: location.href,
    }),
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../../pages/official/pitches.tsx')),
})

/** The link other pages take the path from, instead of respelling it. */
export const officialPitchesLink = { to: NAV_PATHS.officialPitches } as const
